import Contact from "../Contact";
import CosignerQuestion from "../CosignerQuestion";
import EmploymentInformation from "../EmploymentInformation";
import Identification from "../Identification";
import IncomeInformation from "../IncomeInformation";
import Residence from "../Residence";
import TermsAndConditions from "../TermsAndConditions";

const steps = {
    0: () => Contact,
    1: () => Identification,
    2: () => Residence,
    3: () => EmploymentInformation,
    4: () => IncomeInformation,
    5: () => CosignerQuestion,
    6: () => Contact,
    7: () => Identification,
    8: () => Residence,
    9: () => EmploymentInformation,
    10: () => IncomeInformation,
    11: () => TermsAndConditions,
};

export default steps;
